module.exports = __webpack_public_path__ + "img/game_1.1c66589f.png";